// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".IQUF8U_FvfZmIf5vxpYQ{background:rgba(0,0,0,.3);border-radius:4px;font-size:0;padding:0}.nDs9iEpze6DuOtjoAF6h{width:16px;height:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"arrowButton": "IQUF8U_FvfZmIf5vxpYQ",
	"arrowIcon": "nDs9iEpze6DuOtjoAF6h"
};
export default ___CSS_LOADER_EXPORT___;
